import telegramLogo from '../assets/telegram-logo.svg';
import instagramLogo from '../assets/instagram-logo.svg';
import eitaLogo from '../assets/eita-logo.svg';
import baleLogo from '../assets/bale-logo.png';
import rubikaLogo from '../assets/rubika-logo.svg';
import soroushLogo from '../assets/soroush-logo.svg';
import influenceralLogo from '../assets/influenceral-logo.png';
import appIcon from '../assets/app-icon.svg';
import globeIcon from '../assets/globe-icon.png';
import smsLogo from '../assets/sms-icon.png';
import websiteAdLogo from '../assets/broadcast-icon.svg';
import { Media } from '../interfaces/campaign';
import * as XLSX from 'xlsx';
import { ExportToExcelOptions } from '../interfaces/finance';
import convertTitleObject from './convertTitleObject';

const mediaLogoMap: Record<Media, string> = {
	telegram: telegramLogo,
	instagram: instagramLogo,
	eita: eitaLogo,
	bale: baleLogo,
	rubika: rubikaLogo,
	soroush: soroushLogo,
	influenceral: influenceralLogo,
	app: appIcon,
	sms: smsLogo,
	media_growth: globeIcon,
	website_ad: websiteAdLogo,
};

export const getMediaLogo = (app: Media): string => {
	const logo = mediaLogoMap[app];
	if (!logo) {
		console.warn(`No logo found for: ${app}`);
		return '';
	}
	return logo;
};

export const exportToExcel = ({ data, fileName, t }: ExportToExcelOptions): void => {
	let renameData = convertTitleObject(data, t);

	// 1. Create a new workbook
	const workbook = XLSX.utils.book_new();

	// 2. Convert the data to a worksheet
	const worksheet = XLSX.utils.json_to_sheet(renameData);

	// 3. Append the worksheet to the workbook
	XLSX.utils.book_append_sheet(workbook, worksheet, 'sheet');

	// 4. Export the workbook to an Excel file
	XLSX.writeFile(workbook, `${fileName}.xlsx`);
};
